<template>
  <div id="chat-flows-list" class="chat-flows-list-container">
    <chat-flow-view-sidebar
      v-if="sidebarData.id !== undefined"
      :isSidebarActive="addNewDataSidebar"
      @closeSidebar="toggleDataSidebar"
      @refetchChatFlow="fetchChatFlow"
      @setSetting="setSettingByKey"
      :chatOption="sidebarData"
    />

    <vs-popup 
      v-if="this.treeData[0].children.length"
      title="Pré-visualização do Fluxo de Conversa" 
      :active.sync="previewPopupActive"
      class="sizePopup"
    >
      <vs-card> 
        <chat-flow-preview :isPassive="chatFlowType === 'passive'" :treeData="flowExampleChildren" />
      </vs-card>
    </vs-popup>

    <vs-card>
      <div>
        <vs-tabs ref="flowtabs" v-model="selectedTab">
          <vs-tab :label="`Fluxo ${chatFlowType === 'passive' ? 'Bot de Triagem' : 'Bot de Campanhas'}`" icon="build">
            <v-tree
              ref='tree'
              :tpl="tpl"
              :canDeleteRoot="false"
              :data="treeData"
              :draggable="false"
              :halfcheck="true" 
              :multiple="false"
              @node-expand="lastOpening($event)"
            />
          </vs-tab>

          <div v-show="canSee('hours-view') === true">
            <vs-tab label="Horário de Atendimento" icon="schedule">
              <div class="flex">
                <div>
                  <span>Ativar Configuração de Horário do Bot</span>
                  <vs-switch v-model="useScheduling" class="mt-2">
                    <span slot="on">Sim</span>
                    <span slot="off">Não</span>
                  </vs-switch>
                </div>

                <div v-if="useScheduling" class="flex">
                  <div class="ml-5" v-if="hasDepartmentRedirect">
                    <span>Vincular o horário a departamento</span>
                    <vs-switch v-model="useSchedulingInDepartament" class="mt-2">
                      <span slot="on">Sim</span>
                      <span slot="off">Não</span>
                    </vs-switch>
                  </div>
                  <div class="ml-5">
                    <span>Criar intervalos para o Bot</span>
                    <vs-switch v-model="useSchedulingPause" class="mt-2">
                      <span slot="on">Sim</span>
                      <span slot="off">Não</span>
                    </vs-switch>
                  </div>
                </div>
              </div>

              <div v-if="useScheduling">
                <div v-if="useSchedulingInDepartament" class="mt-5 w-full">
                  <div>
                    <span>Selecione o departamento de atuação</span>

                    <div v-if="!departments.length">
                      <small>Sem dados departamentos disponível</small>
                    </div>
                    <div v-else :key="indextr" v-for="(tr, indextr) in departments" class="w-full mb-5">
                      <vs-td class="flex mb-2">
                        <vs-checkbox v-model="departmentScheduleIds" :vs-value="tr.id" :title="tr.name">
                          <div class="flex">
                            <p class="align-self-center">{{ tr.name | truncate(100, true) }}</p>
                          </div>
                        </vs-checkbox>
                      </vs-td>

                      <div class="flex p-5 settings-flow-panel" v-if="departmentScheduleIds.includes(tr.id)">
                        <bot-schedule
                          :use-message-shield="true"
                          :user-department-id="tr.id"
                          :week-days="weekDays[tr.id]"
                          :messages="messages[tr.id]"
                          :use-scheduling-pause="useSchedulingPause"
                          @updatedWeekDays="updatedWeekDays"
                          @updatedMessages="updatedMessages"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else class="mt-8">
                  <bot-schedule
                    :week-days="weekDefaultDays"
                    :use-scheduling-pause="useSchedulingPause"
                    @updatedWeekDays="updatedWeekDays"
                  />

                  <div class="w-full mt-8">
                    <label>Mensagem para enviar fora do horário de atendimento</label>
                    <vs-textarea v-model="passiveBotScheduleMessage" class="mt-3"></vs-textarea>
                  </div>
                  <div v-if="useSchedulingPause" class="w-full mt-8">
                    <label>Mensagem para enviar durante o intervalo do bot no horário de atendimento</label>
                    <vs-textarea v-model="messagePauseBotPassive" class="mt-3"></vs-textarea>
                  </div>
                </div>
              </div>

              <vs-button v-if="canSee('hours-update')" @click="saveSchedule" class="float-right">Salvar</vs-button>
              <vs-button v-else class="float-right" disabled>Salvar</vs-button>
            </vs-tab>
          </div>
          
        </vs-tabs>
      </div>
    </vs-card>
  </div>
</template>

<script>
  import ChatFlowPreview from './ChatFlowPreview'
  import ChatFlowViewSidebar from './ChatFlowViewSidebar'
  import BotSchedule from "../../components/chat-flow/BotSchedule.vue";

  import { VTree, VSelectTree }  from 'vue-tree-halower'
  import {knowledgeType} from "@/supports/reasonSupport";
  import {getChatOptionAsTreeChild, getOptionDataFromNodeTitle, hasPermission} from '@/utils'

  import moduleReasons from "@/store/reasons/moduleReasons";
  import moduleChatFlow from '@/store/chatFlow/moduleChatFlow'
  import moduleSettings from '@/store/settings/moduleSettings'
  import flowExampleChildren from '@/utils/flowExampleChildren.json'
  import moduleCustomerGroup from "@/store/customerGroup/moduleCustomerGroup";
  import moduleUserDepartment from "../../store/userDepartment/moduleUserDepartment";

  const flowLabels = {
    chatFlows: 'Fluxos de Bots',
    flowExample: '<span class="flow-label" style="background-color: #FA9E43">Exemplo de Fluxo</span>',
    passive: '<span class="flow-label" style="background-color: #1E1E1E">Fluxo Bot de Triagem</span>',
    active: '<span class="flow-label" style="background-color: #7367F0">Fluxo Bot de Campanhas</span>'
  } 

  export default {
    name: 'chat-flows-list',
    data() {
      return {
        weekDays:[],
        weekDefaultDays: [],
        messages: [],
        lastOpen: [],
        workingHours: [],
        departmentScheduleIds: [],
        departmentScheduleToRemoveIds: [],
        treeData: [{
          title: flowLabels.chatFlows,
          expanded: true,
          children: []
        }],
        sidebarData: {},
        selectedTab: 0,
        chatFlowType: null,
        isMounted: false,
        alloySleep: false,
        alloyButtons: false,
        useScheduling: false,
        addNewDataSidebar: false,
        useSchedulingPause: false,
        previewPopupActive: false,
        hasDepartmentRedirect: false,
        useSchedulingInDepartament: false,
        messagePauseBotPassive: '',
        passiveBotScheduleMessage: "",
        passiveBotScheduleMessagePause: "",
      }
    },
    computed: {
      chatFlows() {
        return this.$store.state.chatFlow ? this.$store.state.chatFlow.chatFlows : []
      },
      flowExampleChildren() {
        return flowExampleChildren
      },
      settings() {
        return this.$store.state.settings.settings
      },
      backOptionIsActive() {
        return !!parseInt(this.settings.enable_back_option_passive_flow) || false;
      },
      departments() {
        return this.$store.state.userDepartment ? this.$store.state.userDepartment.userDepartments.filter(department => department.activated) : [];
      }
    },
    watch: {
      chatFlows: function (chatOptions) {
        if (this.treeData[0].children.length) {
          const optionsFlow = []

          chatOptions.map(chatOption => {
            optionsFlow.push(getChatOptionAsTreeChild(chatOption, false, false, this.lastOpen))
          })

          this.treeData[0].children[1].children = optionsFlow
        }
        if (chatOptions[0]) {
          this.hasDepartmentRedirect = chatOptions[0].has_department_redirect
        }
      },
      '$route.params.type': function(chatFlowType) {
        this.chatFlowType = chatFlowType
        this.$refs.flowtabs.$data.children[1].attrs.disabled = this.chatFlowType === 'active'
        if (this.$refs.flowtabs.$data.children[1].attrs.disabled) {
          this.selectedTab = 0;
        }
      },
      'chatFlowType': function(chatFlowType) {
        this.treeData[0].children = [
          {
            title: flowLabels.flowExample,
            expanded: false,
            children: flowExampleChildren
          },
          {
            title: flowLabels[chatFlowType],
            expanded: true,
            children: []
          }
        ]

        this.fetchChatFlow();
      },
      useSchedulingInDepartament(value){
        if (!value){
          this.departmentScheduleToRemoveIds = this.departments.map((department) => { return department.id; });
          this.departmentScheduleIds = [];
          this.messages = [];
        }
      },
      departmentScheduleToRemoveIds(departmentIds){
        departmentIds.forEach((departmentId) => {
          this.weekDays[departmentId] = undefined;
        });
      },
      departmentScheduleIds(value, oldValue){
        const itemsToRemove = oldValue.filter(item => !value.includes(item));
        this.departmentScheduleToRemoveIds.push(...itemsToRemove);
      }
    },
    methods: {
      lastOpening(event){
        let number = parseInt(event.title.split(/\D+/).join("|"), 10);

        if (!this.lastOpen.includes(number)) {
          this.lastOpen.push(number);
        } else {
          this.lastOpen.splice(this.lastOpen.indexOf(number), this.lastOpen.length)
        }
      },
      async saveSchedule() {
        if (this.useScheduling) {
          this.weekDays[0] = this.weekDefaultDays;

          const wrongDays = this.weekDays
            .filter(notUndefined => notUndefined !== undefined)
            .flatMap(weekDay => weekDay
              .filter(weekDay => weekDay.selected && weekDay.start_at === weekDay.finish_at)
              .map(weekDay => weekDay.label)
          );

          const wrongPauseDays = this.weekDays
            .filter(notUndefined => notUndefined !== undefined)
            .flatMap(weekDay => weekDay
              .filter(weekDay => weekDay.selected && this.useSchedulingPause && weekDay.start_pause === weekDay.finish_pause && weekDay.start_pause !== '00:00' && weekDay.finish_pause !== '00:00')
              .map(weekDay => weekDay.label)
          );

          const wrongDepartments = this.messages
              .map((message, key) => [key, message])
              .filter(([key, message]) =>
                  this.departmentScheduleIds.includes(key) &&
                  (!message.message || (this.useSchedulingPause && !message.message_pause))
              ).map(([key]) => {
                const department = this.departments.find(department => department.id === key);
                return department ? department.name : null;
              }).filter(name => name);

          const selectedDays = this.weekDays.some(
            weekDay => weekDay.some( day => day.selected )
          )

          if (!selectedDays){
            return this.$vs.notify({
              color: 'danger',
              title: 'Atenção!',
              text: `É necessário ativar o atendimento ao menos em um dia.`
            })
          }

          if (!this.departmentScheduleIds.length && this.useSchedulingInDepartament){
            return this.$vs.notify({
              color: 'danger',
              title: 'Atenção!',
              text: `É necessário configurar ao menos um departamento.`
            })
          }

          if (wrongDays.length || (wrongPauseDays.length && this.useSchedulingPause)) {
            const message = wrongDays.length ? wrongDays : wrongPauseDays
            return this.$vs.notify({
              color: 'danger',
              title: 'Atenção!',
              text: `É necessário configurar corretamente ${ wrongDays.length ? 'o horário' : 'a pausa'} no(s) dia(s): ${message.join(', ')}.`
            })
          }

          if (wrongDepartments.length) {
            return this.$vs.notify({
              color: 'danger',
              title: 'Atenção!',
              text: `É necessário configurar a mensagem fora do horário e/ou pausa no(s) departamentos(s): ${wrongDepartments.join(', ')}.`
            })
          }

          if (!this.departmentScheduleIds.length && (!this.passiveBotScheduleMessage || (this.useSchedulingPause && !this.messagePauseBotPassive))) {
            return this.$vs.notify({
              color: 'danger',
              title: 'Atenção!',
              text: `É necessário configurar a mensagem fora do horário e/ou pausa.`
            })
          }
        } else {
          this.weekDefaultDays = [
            { value: '1', label: 'Segunda-feira', start_at: '00:00', finish_at: '00:00', selected: false, start_pause: '00:00', finish_pause: '00:00' },
            { value: '2', label: 'Terça-feira', start_at: '00:00', finish_at: '00:00', selected: false, start_pause: '00:00', finish_pause: '00:00' },
            { value: '3', label: 'Quarta-feira', start_at: '00:00', finish_at: '00:00', selected: false, start_pause: '00:00', finish_pause: '00:00' },
            { value: '4', label: 'Quinta-feira', start_at: '00:00', finish_at: '00:00', selected: false, start_pause: '00:00', finish_pause: '00:00' },
            { value: '5', label: 'Sexta-feira', start_at: '00:00', finish_at: '00:00', selected: false, start_pause: '00:00', finish_pause: '00:00' },
            { value: '6', label: 'Sábado', start_at: '00:00', finish_at: '00:00', selected: false, start_pause: '00:00', finish_pause: '00:00' },
            { value: '0', label: 'Domingo', start_at: '00:00', finish_at: '00:00', selected: false, start_pause: '00:00', finish_pause: '00:00' },
          ]
          this.passiveBotScheduleMessage = ''
          this.messagePauseBotPassive = ''
        }

        await this.$store.dispatch("userDepartment/deleteSchedule", this.departmentScheduleToRemoveIds);

        if ( this.useSchedulingInDepartament ) {
          this.departmentScheduleIds.forEach((departmentId) => {
            let departmentMessages = this.messages[departmentId];
            departmentMessages = departmentMessages
                ? Object.fromEntries(Object.entries(departmentMessages).map(([key, value]) => [key, btoa(unescape(encodeURIComponent(value)))]))
                : null;

            this.$store.dispatch("userDepartment/addSchedule", {
              'user_department_id': departmentId,
              'value': this.weekDays[departmentId],
              'messages': departmentMessages
            });
          })
        }

        this.$store.dispatch("settings/updatePassiveBotSchedule", {
          passiveBotSchedule: JSON.stringify(this.weekDefaultDays).replace(/"/g, "'"),
          passiveBotScheduleMessage: btoa(unescape(encodeURIComponent(this.passiveBotScheduleMessage))),
          passiveBotScheduleMessagePause: btoa(unescape(encodeURIComponent(this.messagePauseBotPassive))),
          useSchedulingInDepartament: this.useSchedulingInDepartament,
          useScheduling: this.useScheduling
        }).then(() => {
            this.$vs.notify({
              color: 'success',
              title: 'Sucesso!',
              text: 'Suas configurações foram salvas com sucesso.'
            })
          })
          .catch(() => {
            this.$vs.notify({
              color: 'danger',
              title: 'Ocorreu um ao salvar as configurações!',
              text: 'Sentimos muito, um erro ocorreu, por favor, nos contate para corrigir!'
            })
          })
      },
      fetchChatFlow() {
        this.$store.dispatch("chatFlow/fetch", {
          number: null,
          parent_option_id: null,
          type: this.chatFlowType === 'passive' ? 0 : 1
        })
      },
      toggleDataSidebar(val = false) {
        this.addNewDataSidebar = val

        // Clear the sidebarData value to avoid errors when the Sidebar closes
        if (!val) {
          this.sidebarData = {}
        }
      },
      async addNewData(parentOptionId, optionNumber, isFlow = false, departmentId = null, priority = null, groupId = null, reasonOptionId = null, reasonId = null) {
        let parentHasOptions, currentNodeHasBackOption;

        if ( parentOptionId && this.backOptionIsActive ) {
          await this.$store.dispatch("chatFlow/backInfos", parentOptionId).then(
            response => {
              [ parentHasOptions, currentNodeHasBackOption ] = response.data.data.backInfos;
            }
          );
        }

        optionNumber = (currentNodeHasBackOption) ? optionNumber - 1 : optionNumber;
        reasonOptionId = !isNaN(reasonOptionId) ? reasonOptionId : null;
        departmentId = !isNaN(departmentId) ? departmentId : null;
        reasonId = !isNaN(reasonId) ? reasonId : null;
        priority = !isNaN(priority) ? priority : null;
        groupId = !isNaN(groupId) ? groupId : null;

        if (isFlow) {
          this.sidebarData = {
            id: null,
            number: null,
            priority: null,
            group_id: null,
            description: '',
            reason_id: null,
            reason_option_id: null,
            parent_option_id: null,
            hide_last_checkbox: true,
            type: this.chatFlowType === 'passive' ? 0 : 1
          }
        } else {
          this.sidebarData = {
            id: null,
            number: optionNumber + 1,
            parent_priority: priority,
            description: '',
            reason_id: reasonId,
            parent_group: groupId,
            reason_option_id: reasonOptionId,
            parent_option_id: parentOptionId,
            parent_user_department: departmentId,
            type: this.chatFlowType === 'passive' ? 0 : 1,
            hide_last_checkbox: (optionNumber === 0 && currentNodeHasBackOption) ? true : Boolean(optionNumber),
            parent_has_options: Boolean(parentHasOptions),
            current_node_has_back_option: Boolean(currentNodeHasBackOption),
            back_option_is_active: this.backOptionIsActive
          }
        }

        this.toggleDataSidebar(true)
      },
      editData(chatFlowId, parentId, optionNumber, departmentId, priority, groupId, reasonOptionId, reasonId, nodeTitle, children) {
        groupId  = !isNaN(groupId) ? groupId : null
        parentId = !isNaN(parentId) ? parentId : null
        priority = !isNaN(priority) ? priority : null
        reasonId = !isNaN(reasonId) ? reasonId : null
        optionNumber = !isNaN(optionNumber) ? optionNumber : null
        departmentId = !isNaN(departmentId) ? departmentId : null
        reasonOptionId = !isNaN(reasonOptionId) ? reasonOptionId : null

        this.sidebarData = {
          id: chatFlowId,
          number: optionNumber,
          parent_priority: priority,
          description: nodeTitle,
          parent_group: groupId,
          reason_id: reasonId,
          parent_option_id: parentId,
          reason_option_id: reasonOptionId,
          parent_user_department: departmentId,
          type: this.chatFlowType === 'passive' ? 0 : 1,
          children: children,
          back_option_is_active: this.backOptionIsActive
        }

        this.toggleDataSidebar(true)
      },
      deleteData(chatFlowId, parentId) {
        parentId = !isNaN(parentId) ? parentId : null
        this.$vs.dialog({
          type:'confirm',
          color: 'danger',
          title: `Deseja remover a opção?`,
          text: 'A opção e suas sub-opções serão excluídas em cadeia',
          accept: () => this.confirmDelete(chatFlowId, parentId),
          acceptText: 'Confirmar',
          cancelText: 'Voltar'
        })
      },
      confirmDelete(id, parent_option_id) {
        this.$store.dispatch("chatFlow/delete", {id, parent_option_id}).then(() => {
          this.fetchChatFlow()

          if (parent_option_id === null && this.chatFlowType === 'passive' ){
            this.setSettingByKey('use_department_schedule', false)
          }

          this.$vs.notify({
            title: "Sucesso",
            text: "Opção deletada com sucesso",
            color: "success",
          });
        })
      },
      tpl (...args) {
        const notAllowed = [
          flowLabels.chatFlows,
          flowLabels.passive,
          flowLabels.active
        ]

        const { 0: node, 2: parent } = args

        let nodeTitle = node.title;

        if (nodeTitle === flowLabels.flowExample || node.halfcheck) {
          return (
            <span>
              <span domPropsInnerHTML={nodeTitle}></span>
              {
                nodeTitle === flowLabels.flowExample
                ? (
                  <button
                    onClick={() => this.openPreviewPopup()}
                    class="btn-async border-none cursor-pointer px-2 py-1 ml-2 rounded"
                    style="background-color: #0ca8a0; color: #FFF;"
                  >
                    pré-visualização
                  </button>
                )
                : null
              }
            </span>
          )
        }

        const {optionId, optionNumber, parentId, departmentId, priority, newNodeTitle} = getOptionDataFromNodeTitle(nodeTitle, parent)

        if (notAllowed.indexOf(nodeTitle) !== -1) {
          if (nodeTitle !== flowLabels.chatFlows) {
            let canAddFlow = true

            if (
              (nodeTitle === flowLabels.passive &&
              node.children.length > 0) ||
              this.canSee('add') === false
            ) {
              canAddFlow = false
            }

            return (
              <span>
                <span domPropsInnerHTML={nodeTitle}></span>

                {
                  canAddFlow ?
                  (<button class="btn-async text-info border-none cursor-pointer px-2 py-1 ml-2 rounded" onClick={() => this.addNewData(
                      null,
                      0,
                      true,
                      departmentId,
                      priority,
                      node.group,
                      node.reasonOption,
                      node.reason
                  )}>
                      adicionar fluxo
                    </button>)
                  : null
                }
              </span>
            )
          }

          return (
            <span>
              <span domPropsInnerHTML={nodeTitle}></span>
            </span>
          )
        }

        nodeTitle = newNodeTitle;

        if (!node.children.length && isNaN(optionNumber) && parentId && node.children[0] && node.children[0].is_close) {
          return (
            <span>
              <span domPropsInnerHTML={nodeTitle}></span>

              {
                this.canSee('update') ?
                (<button
                  class="btn-update text-primary border-none cursor-pointer ml-2 px-2 py-1 rounded" 
                  onClick={() => this.editData(
                      optionId,
                      parentId,
                      optionNumber,
                      departmentId,
                      priority,
                      node.group,
                      node.reasonOption,
                      node.reason,
                      nodeTitle,
                      node.children[0]
                  )}
                >
                  editar
                </button>)
                : null
              }
              

              {
                this.canSee('delete') ?
                (<button
                  class="btn-delete text-danger border-none cursor-pointer ml-2 px-2 py-1 rounded" 
                  onClick={() => this.deleteData(optionId, parentId)}
                >
                  remover
                </button>)
                : null
              }
            </span>
          )
        }

        let canAddOption = true
        let canShowWarning = this.alloyButtons && !isNaN(optionNumber) && node.type === 0 && node.lenght && node.lenght > 20

        if (
          (
            node.children.length === 1 && 
            node.children[0].title.indexOf('|null|') !== -1
          ) ||
          (
            this.canSee('add') === false ||
            optionNumber === 0
          )
        ) {
          canAddOption = false
        }
        
        return (
          <span>
            <span domPropsInnerHTML={nodeTitle}></span>

            {canShowWarning ?
            (
              <button class="btn-async bg-warning border-none cursor-pointer px-2 py-1 ml-2 rounded">
                <vx-tooltip color="warning" text="ATENÇÃO: Opção tem mais de 20 caracteres, diminua para funcionar as mensagens interativas.">
                  <feather-icon icon="AlertTriangleIcon" svgClasses="w-3 h-3 text-info"/>
                </vx-tooltip>
              </button>
            ) : null}

            { canAddOption && node.is_close === false ? 
            (
              <button class="btn-async text-info border-none cursor-pointer px-2 py-1 ml-2 rounded" onClick={() => this.addNewData(optionId, node.children.length)}>
                adicionar opção
              </button>
            )
            : null}
            
            { this.canSee('update') ?
              (<button 
                class="btn-update text-primary border-none cursor-pointer ml-2 px-2 py-1 rounded" 
                onClick={() => this.editData(
                    optionId,
                    parentId,
                    optionNumber,
                    departmentId,
                    priority,
                    node.group,
                    node.reasonOption,
                    node.reason,
                    nodeTitle,
                    node.children[0]
                )}
              >
                editar
              </button>)
              : null
            }

            { this.canSee('delete') ?
              (<button 
                class="btn-delete text-danger border-none cursor-pointer px-2 py-1 ml-2 rounded" 
                onClick={() => this.deleteData(optionId, parentId)}
              >
                remover
              </button>)
              : null
            }
          </span>
        )
      },
      openPreviewPopup() {
        this.previewPopupActive = true
      },
      updatedWeekDays(weekDays, userDepartmentId){
        if (userDepartmentId === null){ this.weekDefaultDays = weekDays; }
        this.weekDays[userDepartmentId] = weekDays
      },
      updatedMessages(messages, userDepartmentId){
        this.messages[userDepartmentId] = messages
      },
      canSee(action) {
        return hasPermission(`${this.$route.name}-${action}`)
      },
      setSettingByKey(key, value){
        this.$store.dispatch("settings/updateKeyValue", { key: key, value: value }).then(() => {
          this.getSettingsValues();
        })
      },
      getSchedules(){
        this.departments.forEach((department) => {
          if ( !!department.schedule ){
            this.weekDays[department.id] = department.schedule.value
            this.messages[department.id] = department.schedule.messages
            this.departmentScheduleIds.push(department.id)
          }
        });

        this.useSchedulingPause = this.weekDays.some(
          weekDay => weekDay.some(
            day => day.start_pause !== "00:00" && day.finish_pause !== "00:00"
          )
        )
      },
      getSettingsValues() {
        const { passive_bot_schedule, passive_bot_schedule_message, passive_bot_schedule_message_pause, use_scheduling, alloy_sleep_passive_flow, buttons_in_passive_flow, use_department_schedule } = this.settings

        if (passive_bot_schedule) {
          this.weekDefaultDays = JSON.parse(passive_bot_schedule)
        }

        if (passive_bot_schedule) {
          this.passiveBotScheduleMessage = passive_bot_schedule_message
        }

        if (passive_bot_schedule_message_pause) {
          this.messagePauseBotPassive = passive_bot_schedule_message_pause 
        }

        this.useScheduling = !!parseInt(use_scheduling)
        this.alloySleep = !!parseInt(alloy_sleep_passive_flow)
        this.alloyButtons = !!parseInt(buttons_in_passive_flow)
        this.useSchedulingInDepartament = !!parseInt(use_department_schedule)
      },
      async fetchComponents(){
        await this.$store.dispatch("customerGroup/fetchGroupsOfCustomerResume");
        await this.$store.dispatch("settings/fetch").then(() => { this.getSettingsValues(); })
        await this.$store.dispatch("userDepartment/fetch").then(() => { this.getSchedules(); })
        if ( this.alloySleep ) await this.$store.dispatch("reasons/fetch", {deleted: false, type: knowledgeType});
      }
    },
    created() {
      if (!moduleChatFlow.isRegistered) {
        this.$store.registerModule('chatFlow', moduleChatFlow)
        moduleChatFlow.isRegistered = true
      }

      if (!moduleSettings.isRegistered) {
        this.$store.registerModule('settings', moduleSettings)
        moduleSettings.isRegistered = true
      }

      if (!moduleCustomerGroup.isRegistered) {
        this.$store.registerModule('customerGroup', moduleCustomerGroup)
        moduleCustomerGroup.isRegistered = true
      }

      if (!moduleReasons.isRegistered) {
        this.$store.registerModule('reasons', moduleReasons)
        moduleReasons.isRegistered = true
      }

      if (!moduleUserDepartment.isRegistered) {
        this.$store.registerModule('userDepartment', moduleUserDepartment)
        moduleUserDepartment.isRegistered = true
      }

      this.chatFlowType = this.$route.params.type;
    },
    async mounted() {
      this.isMounted = true;
      this.$refs.flowtabs.$data.children[1].attrs.disabled = this.chatFlowType === 'active'
      await this.fetchComponents()
    },
    beforeRouteLeave(to, from, next) {
      if (this.addNewDataSidebar) {
        this.addNewDataSidebar = false;
        setTimeout( ()=> {
          next();
        }, 2);
      } 
      else {
        next();
      }
    },
    components: {
      VTree,
      VSelectTree,
      BotSchedule,
      ChatFlowPreview,
      ChatFlowViewSidebar
    }
  }
</script>

<style lang="scss">
  @import "@/assets/scss/vuexy/extraComponents/tree.scss";

  .settings-flow-panel {
    border: 3px dotted rgba(0, 0, 0, 0.2);
    box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
    border-radius:10px;
  }

  #chat-flows-list {
    .flow-label {
      color: #fff;
      border-radius: 20px;
      font-size: .8rem;
      padding: 4px 8px;
    }
  
    .con-slot-label {
      font-size: 1rem !important;
    }
  }

</style>
